import styled from "styled-components";

const StyledLogoBar = styled.div`
  /* Full-bleed black bar across the viewport */
  width: 100vw;
  margin-left: calc(50% - 50vw);
  margin-right: calc(50% - 50vw);
  background: #000;
`;

const Img = styled.img`
  display: block;
  /* Mobile: logo spans the full bar width */
  width: 100%;
  height: auto;

  /* Desktop: logo takes 50% of the bar, centered */
  @media (min-width: 768px) {
    width: 50%;
    margin-left: auto;
    margin-right: auto;
  }
`;

function Logo() {
  const src = "/UnicorNation-negative.png";

  return (
    <StyledLogoBar>
      <Img src={src} alt="Logo" />
    </StyledLogoBar>
  );
}

export default Logo;
